import { render } from "./HeroiconsOutlineCubeTransparent.vue?vue&type=template&id=625dca67"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCubeTransparent.vue"]])

export default __exports__